import { ToolReducer } from '../Redux/Reducers/ToolReducer.js';
import { VideoCompresserReducer } from '../Redux/Reducers/VideoCompressor.js';
import { combineReducers } from 'redux';

export default combineReducers( {
	ToolReducer,
	VideoCompresserReducer
} );
